<template>
  <div class="compete-contact">
    <div class="contact-content">
      <div class="contact-header">
        请参赛团队长加入微信群，群里会不定期更新赛事重要信息
      </div>
      <div class="contact-main">
        <div class="main-img">
          <img alt="wechat" :src="wechatQrCode" />
        </div>
        <div class="main-text">
          <div class="text">
            <div class="text-item">
              <div>微信扫码直接入群</div>
            </div>
            <div class="text-item">组队协助、Q&A答疑、领奖沟通、欢迎加入</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompeteContact',
  data() {
    return {
      wechatQrCode: window.financialCompetitionResource.wechatQrCode
    }
  }
}
</script>

<style lang="scss" scoped>
.compete-contact {
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 64px;
  display: flex;
  justify-content: center;
  .contact-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .contact-header {
      font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
        Verdana, 'PingFang SC';
      font-size: 30px;
      color: #333333;
      letter-spacing: 0;
      line-height: 42px;
    }
    .contact-main {
      margin-top: 40px;
      display: flex;
      .main-img {
        width: 316px;
        height: 288px;
        position: relative;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      .main-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 60px;
        .text-item {
          &:first-of-type {
            font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei',
              sans-serif, Verdana, 'PingFang SC';
            font-size: 24px;
            color: #333333;
            letter-spacing: 0;
            line-height: 34px;
            font-weight: bold;
            span {
              color: #ffcc66;
            }
          }
          &:last-of-type {
            margin-top: 16px;
            font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei',
              sans-serif, Verdana, 'PingFang SC';
            font-size: 16px;
            color: #333333;
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/competeContact.vue